export default __webpack_public_path__ + "static/media/1.482b91ff.png";